// This file MUST be imported first in main.tsx
// It configures logging before any other modules load

(globalThis as Record<string, unknown>).__LOG_CONFIG__ = {
  enabled: true,
  subsystems: {
    AUTH: false, // disable AUTH logging
  },
};
